export function preloadImage(
  url: string,
  anonymous = false,
): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();

    if (anonymous) {
      img.crossOrigin = "anonymous";
    }

    img.onerror = function (e) {
      console.error({ url, error: e });
      reject(e);
    };

    img.onload = function () {
      resolve(img);
    };

    img.src = url;
  });
}
